import { Pipe, PipeTransform } from '@angular/core';
import { GridItem, ColumnCommand } from '../grid-control.model';
@Pipe({
  name: 'columnCommandFilter'
})
export class ColumnCommandFilterPipe implements PipeTransform {
  async transform(commands: ColumnCommand[], item: GridItem): Promise<ColumnCommand[]> {
    const results: ColumnCommand[] = [];
    if (!commands) {
      return results;
    }
    for (const command of commands) {
      const { hiddenByItem } = command;
      if (!hiddenByItem) {
        results.push(command);
      } else {
        const hidden = hiddenByItem(item);
        if (hidden instanceof Promise) {
          if (!await hidden) {
            results.push(command);
          }
        } else {
          if (!hidden) {
            results.push(command);
          }
        }
      }
    }
    return results;
  }
}
